import { render } from "./introduction.vue?vue&type=template&id=0d6de452&ts=true"
import script from "./introduction.vue?vue&type=script&lang=ts"
export * from "./introduction.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__